import React, { Component } from 'react';
import { translate } from 'react-i18next';
import Table from 'antd/lib/table';
import Button from 'antd/lib/button';
import Popconfirm from 'antd/lib/popconfirm';
import message from 'antd/lib/message';
import Spin from 'antd/lib/spin';
import mobileApi from '../api';

@translate()
export default class DeviceList extends Component {
  state = {
    devices: [],
    loading: false,
    deactivating: null,
  };

  componentDidMount() {
    this.fetchDevices();
  }

  fetchDevices = async () => {
    this.setState({ loading: true });
    const response = await mobileApi.fetchDevices();
    if (response.ok) {
      this.setState({ devices: response.data || [] });
    }
    this.setState({ loading: false });
  };

  handleDeactivate = async (deviceId) => {
    const { t } = this.props;
    this.setState({ deactivating: deviceId });
    const response = await mobileApi.deactivateDevice(deviceId);
    if (response.ok) {
      message.success(t('Zariadenie bolo deaktivované'));
      this.fetchDevices();
    }
    this.setState({ deactivating: null });
  };

  render() {
    const { t } = this.props;
    const { devices, loading, deactivating } = this.state;

    const columns = [
      {
        title: t('Názov zariadenia'),
        dataIndex: 'device_name',
        key: 'device_name',
        render: (text) => text || '—',
      },
      {
        title: t('Platforma'),
        dataIndex: 'platform',
        key: 'platform',
        render: (text) => text || '—',
      },
      {
        title: t('Registrované'),
        dataIndex: 'created_at',
        key: 'created_at',
        render: (text) =>
          text ? new Date(text).toLocaleDateString('sk-SK') : '—',
      },
      {
        title: t('Posledná aktivita'),
        dataIndex: 'last_active_at',
        key: 'last_active_at',
        render: (text) =>
          text ? new Date(text).toLocaleDateString('sk-SK') : '—',
      },
      {
        title: '',
        key: 'actions',
        render: (_, record) => (
          <Popconfirm
            title={t('Naozaj chcete deaktivovať toto zariadenie?')}
            onConfirm={() => this.handleDeactivate(record.id)}
            okText={t('Áno')}
            cancelText={t('Nie')}
          >
            <Button
              type="danger"
              size="small"
              loading={deactivating === record.id}
            >
              {t('Deaktivovať')}
            </Button>
          </Popconfirm>
        ),
      },
    ];

    return (
      <div style={{ marginTop: 24 }}>
        <h3>{t('Mobilné zariadenia')}</h3>
        <Spin spinning={loading}>
          <Table
            dataSource={devices}
            columns={columns}
            rowKey="id"
            pagination={false}
            locale={{ emptyText: t('Žiadne zaregistrované zariadenia') }}
            size="small"
          />
        </Spin>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/user-settings/components/DeviceList.js